import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ProgressService } from './progress.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {

  constructor(private progressService: ProgressService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.progressService.startProgress(); // Start progress when request begins

    return next.handle(req).pipe(
      finalize(() => {
        this.progressService.completeProgress(); // Complete progress when request finishes
      })
    );
  }
}

